import React from "react";
import { useQuery, gql } from '@apollo/client';
import Parser from 'html-react-parser';
import { Link } from "react-router-dom";
import DocumentMeta from 'react-document-meta';
import ReactGA from 'react-ga4';

const GET_PRIVACY_POLICY_CMS = gql`{cmsPage(identifier: "privacy-policy-cookie-restriction-mode") {identifier url_key title content content_heading}}`;

const Privacy = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: 'Privacy Policy', });
  const meta = {
      title: 'Privacy Policy',
      description: 'This is test Privacy Policy page On React demo for react and seo practice.',
      canonical: window.location.href,
      meta: {
        charset: 'utf-8',
        name: {
            title: 'Privacy Policy',
            keywords: 'react,meta,document,html,tags',
            robots: 'INDEX,FOLLOW',
        }
      }
    };
  const { data, error, loading } = useQuery(GET_PRIVACY_POLICY_CMS);
  if (loading) return <div className="loader-container"><div className="cust-loader"><img src="/assets/images/loader-2.gif" alt="Loading..." /></div></div>;
  if (error) return <p>Error: {error.message}</p>;
  return (
    <>
      <DocumentMeta {...meta}>
        <h1 className="page-title">
          <span className="page-title-wrapper" >{data.cmsPage.content_heading}</span>    
        </h1>
        <div>
          {Parser(data.cmsPage.content)}
        </div>
        <div>
          <Link to="/contact">Contact Us</Link>
        </div>
      </DocumentMeta>
    </>
  );
};
 
export default Privacy;